import { NetworkError, type HttpClient, type SessionLifetime } from '@/model';
import { acknowledgedCapabilities } from './capabilities';

type DeviceWriter = (lifetime: SessionLifetime, deviceId: string, body: Record<string, unknown>) => Promise<void>;
const writers = new WeakMap<HttpClient, DeviceWriter>();
export function bindDeviceRegistration(http: HttpClient, writer: DeviceWriter): void { writers.set(http, writer); }
/** Subscription changes and ordinary metadata share Session's account queue and Support admission. */
export async function writeDeviceRegistration(http: HttpClient, lifetime: SessionLifetime | null, deviceId: string, body: Record<string, unknown>): Promise<void> {
  if (!lifetime || !deviceId.trim()) throw new NetworkError('This account session has ended');
  const writer = writers.get(http), captured = structuredClone(body);
  if (writer) return writer(lifetime, deviceId, captured);
  // Non-session hosts (including transport-edge fixtures) retain strict old-server compatibility.
  delete captured.capabilities;
  if (acknowledgedCapabilities(http).get().includes('support.v1')) captured.capabilities = ['support.v1'];
  await http.put(`/v1/me/devices/${encodeURIComponent(deviceId)}`, captured);
}
